( function ( $, window, document, undefined ) {

	new WOW().init();
	Navigation.start();
	
	var lazyLoadInstance = new LazyLoad({});

	// listen for scroll events
	function checkPageScroll(){
		var $win = jQuery( window );
		$( 'body' ).toggleClass( 'scrolled', jQuery( document ).scrollTop() > 0 );
		$( 'body' ).toggleClass( 'bottom', $win.height() + $win.scrollTop() == jQuery(document).height() );
	}
	$( document ).scroll( checkPageScroll );
	$( document ).ready( checkPageScroll );
	$( window ).on( "load", checkPageScroll );
	checkPageScroll();

	// anchor tag scroll mechanism
	if ( document.querySelectorAll ) {
		var anchors = document.querySelectorAll( 'a[href^="#"]' );
		for ( var i = 0; i < anchors.length; i++ ) {
			var anchor = anchors[i];
			anchor.addEventListener( 'click', function (e) {
				e.preventDefault();
				var selector = document.querySelector( this.getAttribute( 'href' ) );
				if ( selector ) {
					selector.scrollIntoView( {
						behavior: 'smooth'
					} );
				}
			});
		}
	}

} )( jQuery, window, document );

(function ($, window, document, undefined) {

	GlobalVideoPlayer = ( function() {

		function Constructor() {

			var player    = $( '#global-video-player' );
			var underlay  = player.find( '.underlay' );
			var video     = player.find( 'video' );
			var source    = player.find( 'source' );
			var close     = player.find( '.close' );
			var status    = 'closed';
			var type      = 'video';
			var position;

			video.on( 'ended', closePlayer );

			underlay.click( closePlayer );
			close.click( closePlayer );

			$( document ).on( 'keydown', function( event ) {
				if ( status == 'open' && event.key == "Escape" ) {
					closePlayer();
				}
			} );

			function closePlayer() {

				status = 'closed';
				$('html').removeClass( 'noscroll' );
				$( window ).scrollTop( position );
				player.addClass( 'closing' );
				player.removeClass( 'active' );

				if ( type == 'video' ) {
					video[0].pause();
					setTimeout( function () {
						player.removeClass( 'closing' );
						video[0].pause();
					}, 1000 );
				} else {
					setTimeout( function () {
						player.removeClass( 'closing' );
						player.find( 'iframe' ).remove();
					}, 1000 );
				}

			}

			this.src = function ( src_str, src_type ) {

				if ( ! src_type ) {
					src_type = 'video';
				}

				type = src_type;
				status = 'open';
				player.addClass( 'active' );
				player.addClass( 'type_' + src_type );

				if ( type == 'video' ) {
					source.prop( 'src', src_str );
					video[0].load();
					setTimeout( function () {
						position = $( window ).scrollTop();
						$( 'html' ).addClass( 'noscroll' );
						video[0].play();
					}, 1000 );
				} else {
					player.append( '<iframe src="' + src_str + '"><iframe>');
					setTimeout( function () {
						position = $( window ).scrollTop();
						$( 'html' ).addClass( 'noscroll' );
					}, 1000 );
				}


			};

		}
		return new Constructor();

	}() );

})(jQuery, window, document);